module.exports = __webpack_public_path__ + "img/achievement2.fb7effdd.jpeg";